<template>
    <div>
        <div class="box highlight" v-if="(standard && free) && additionalDelivery <= 0">
            <div class="box-inner box-copy blue basket-free-shipping">
                <div class="basket-free-shipping__emblem">
                    <strong>Free</strong> Shipping  <br>{{ postcode }}
                </div>
                <template v-if="remaining > 0">
                    Only spend<div class="basket-free-shipping__price"><small>£</small><strong>{{ remaining|number_format(true) }}</strong></div> more &amp; receive free shipping!
                </template>
                <template v-else>
                    You've spent enough for <div class="basket-free-shipping__price"><strong>FREE</strong></div> shipping!
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Postcode from '../../Services/Postcode.js';
    import Order from '../../Services/Order.js';
    import Basket from '../../Services/Basket.js';

    export default {
        data() {
            return {
                lookup: Postcode,
                order: Order,
                basket: Basket,
                standard: null,
                free: null,
            }
        },
        mounted() {
            if (this.postcode) {
                this.fetch();
            }
        },
        methods: {
            fetch() {
                this.order.getEstimatedShipping(this.postcode, this.subTotal).then(response => {
                    this.standard = _.find(response, price => {
                        return price.rate > 0;
                    });
                    this.free = _.find(response, price => {
                        return price.rate == 0;
                    });
                });
            }
        },
        watch: {
            postcode() {
                this.fetch();
            }
        },
        computed: {
            postcode() {
                return this.lookup.postcode;
            },
            subTotal() {
                return this.basket.basket.sub_total;
            },
            remaining() {
                return this.free.min_basket - (this.subTotal * 100);
            },
            additionalDelivery() {
                return this.basket.additionalDelivery();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/ShippingBadge.vue